import React from 'react'
import HtmlParser from 'react-html-parser'
import Slider from 'components/Slider/Slider'
import { currencyCodeList } from 'constants/currencyCodeList'
import Icon from 'icons/Icon'
import useTopPerformance from './hooks/useTopPerformance'
import { getGameUrl } from 'utils/helpers'
import TopPerformanceCard from './TopPerformanceCard'
import './styles/index.scss'

const TopPerformanceV1 = () => {
  const {
    topGames,
    navigate,
    topPlayers,
    languageData,
    currentWinners,
    selectedLanguageCode
  } = useTopPerformance()

  return (
    <>
      <div className='top-performance-wrapper'>
        <div className='wrapper-block'>
          <div className='winner-card-content'>
            <h4 className='text-center mb-3 winner-card-content-title' title={languageData?.homeCurrentWinners}><Icon name='star-sharp' className='winner-card-star-icon' /> &nbsp;&nbsp;{languageData?.homeCurrentWinners && HtmlParser(languageData?.homeCurrentWinners)}</h4>
            <div className='auto-scroll-wrapper'>
              {
                currentWinners?.length > 0 &&
                  <Slider
                    slides={currentWinners}
                    isVertical
                    autoPlay
                    showHeader={false}
                    showNavigation={false}
                    autoPlayInterval={3000}
                    sliderCard={({
                      index,
                      game: item
                    }) => (
                      <TopPerformanceCard
                        key={`top-performance__current-winners__${index}`}
                        type='current-winners'
                        index={index}
                        imageUrl={item?.thumbnailUrl}
                        title={`${item?.username || ''}`}
                        subtitle={item?.gameName}
                        infoTextTitle='Win:'
                        infoTextValue={`${currencyCodeList?.[item?.currencyCode]}${item?.win}`}
                        onClick={() => {
                          navigate(getGameUrl(selectedLanguageCode?.toLowerCase(), item?.gameId, item?.gameName, item?.providerDisplayName || item?.provider))
                        }}
                      />
                    )}
                  />
              }

              {(currentWinners?.length === 0 || currentWinners === undefined) && <h4 className='text-center'>{languageData?.noDataFound}</h4>}
            </div>
          </div>
        </div>

        <div className='wrapper-block flex-grow-2'>
          <div className='winner-card-content'>
            <div className='top-winners-highlight-logo'><img src={languageData?.topWinnersHighlightLogo} alt='top-winners-highlight-logo' /></div>
            <h4 className='text-center mb-3 winner-card-content-title' title={languageData?.homeTopWinners}><Icon name='star-sharp' className='winner-card-star-icon' />&nbsp;&nbsp;{languageData?.homeTopWinners && HtmlParser(languageData?.homeTopWinners)}</h4>
            <div className='winner-listing-wrap'>
              {
                Array.isArray(topPlayers) &&
                topPlayers?.length > 0 &&
                topPlayers?.slice(0, 3).map((item, i) => {
                  const imageUrls = [
                    languageData?.topWinnersRank1,
                    languageData?.topWinnersRank2,
                    languageData?.topWinnersRank3
                  ]
                  return (
                    <TopPerformanceCard
                      key={`top-performance__top-winners__${item?.userId ?? i}`}
                      type='top-winners'
                      index={i}
                      imageUrl={imageUrls[i]}
                      title={`${item?.username}`}
                      subtitle={item?.multiplier ? `${Number(item.multiplier).toFixed(2)}x` : ''}
                      infoTextTitle='Win:'
                      infoTextValue={`${currencyCodeList?.EUR}${item?.totalWin}`}
                    />
                  )
                })
              }

              {(!Array.isArray(topPlayers) || topPlayers?.length === 0) && <h4 className='text-center'>{languageData?.noDataFound}</h4>}
            </div>
          </div>
        </div>

        <div className='wrapper-block'>
          <div className='winner-card-content'>
            <h4 className='text-center mb-3 winner-card-content-title' title={languageData?.homeTopGames}><Icon name='star-sharp' className='winner-card-star-icon' />&nbsp;&nbsp;{languageData?.homeTopGames && HtmlParser(languageData?.homeTopGames)}</h4>
            <div>
              {topGames?.map((item, i) => {
                return i < 3 && item.payout !== 'Infinity %' && (
                  <TopPerformanceCard
                    key={`top-performance__top-games__${item?.identifier}__${i}`}
                    type='top-games'
                    index={i}
                    imageUrl={item?.thumbnailUrl}
                    title={item?.gameName}
                    subtitle={item?.studioDisplayName || item?.studioName || item?.providerDisplayName || item?.provider}
                    infoTextTitle={`${languageData?.payout || 'Payout'}:`}
                    infoTextValue={`${item?.payout}`}
                    onClick={() => {
                      navigate(getGameUrl(selectedLanguageCode?.toLowerCase(), item?.gameId, item?.gameName, item?.providerDisplayName || item?.provider))
                    }}
                  />
                )
              }
              )}
              {(topGames?.length === 0 || topGames === undefined) && <h4 className='text-center'>{languageData?.noDataFound}</h4>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopPerformanceV1
